/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Typography } from '@mui/material';
import { HideSmallSpan } from './styles';
import { Row } from '../row';

export default (props) => {
  const { primary, secondary, hideSmallPrimary, ...rest } = props;
  return (
    <Typography component={'div'} variant={'body2'} {...rest}>
      <Row>
        <HideSmallSpan hide={!!hideSmallPrimary}>
          {primary}
        </HideSmallSpan>
        {secondary && <>{secondary}</>}
      </Row>
    </Typography>
  );
};
